import { IApplicationState } from 'setup/store'

export const selectProfileInfo = (state: IApplicationState) => state.profile.data
export const selectProfileCommunication = (state: IApplicationState) => state.profile.communications

export const selectSlotsHistory = (state: IApplicationState) => state.profile.data.slotsHistory

export const selectSlotsHistoryComm = (state: IApplicationState) => state.profile.communications.getSlotsHistory
export const selectChangePasswordComm = (state: IApplicationState) => state.profile.communications.changePassword

export const selectUploadDocumentComm = (state: IApplicationState) => state.profile.communications.uploadDocument
